import { lazyLoad } from 'utils/loadable';

export const NotificationsPage = lazyLoad(
  () => import('./NotificationsPage'),
  module => module.NotificationsPage,
);
